<template>
    <main class="page-news app__main">
        <div class="container">
            <h1 class="page-news__title" v-html="title"></h1>

            <category-filter class="page-news__category-filter">
                <template slot="categories">
                    <slot name="category-filter"></slot>
                </template>
            </category-filter>

            <div class="row">
                <slot name="cards"></slot>
            </div>

            <nav class="row">
                <paginator class="col-12">
                    <slot name="pagination"></slot>
                </paginator>
            </nav>
        </div>
    </main>
</template>

<script>
    import Card from '@/components/Card';
    import CategoryFilter from '@/components/CategoryFilter';
    import Paginator from '@/components/Paginator';

    export default {
        name: 'PageNews',

        components: {
            Card,
            CategoryFilter,
            Paginator,
        },

        props: {
            title: { type: String, required: true },
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .page-news {
        &__title {
            @extend %font-OpenSans-light;

            display:     flex;
            align-items: center;

            min-height:  6.8rem;
            margin:      0;
            padding:     2rem 0;

            color:       $gray-500;
            font-size:   3rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                font-size: 5rem;
            }
        }

        &__category-filter {
            margin-bottom: 2rem;
        }

        &__column {
            display: flex;
        }
    }
</style>
